module.exports = "/images/Publish.svg";